import * as debug from "debug";
//import * as supportsColor from "supports-color"; // only for NodeJS to enable more colors

// to enable write on console: localStorage.debug = 'prompt:*'
const NS_BASE = 'prompt';
// TODO create namespaces per app name? we can't read app dir on filesystem and we want to avoid missing logs due to include order (from another lib using this class)

/*
const COLORS = {
    trace: 'lightblue',
    info: 'blue',
    warn: 'pink',
    error: 'red'
};
*/

class Log {
    // https://www.npmjs.com/package/debug#formatters
    constructor() {
    }

    public trace(formatter: any, ...args: any[]): void {
    }

    public verbose(formatter: any, ...args: any[]): void {
    }

    public info(formatter: any, ...args: any[]): void {
    }

    public warn(formatter: any, ...args: any[]): void {
    }

    public error(formatter: any, ...args: any[]): void {
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################
}

const logger = new Log();
/*
Object.keys(COLORS).forEach((logLevel) => {
    console.log(logLevel, COLORS[logLevel])
    //debug.colors = COLORS[logLevel];
});
debug.colors = COLORS;
*/
logger.trace = debug(NS_BASE + ":trace" );
logger.verbose = debug(NS_BASE + ":verbose" );
logger.info = debug(NS_BASE + ":info" );
logger.warn = debug(NS_BASE + ":warn" );
logger.error = debug(NS_BASE + ":error" );

export {logger}
